import { Box, FlexBox, Icon, Text } from '@dixa/lib-shared-habla';
import { PropsWithChildren } from 'lib-shared-types-utils';

import styles from './styles.module.scss';

interface Props extends PropsWithChildren {
  description: string;
  title: string;
  tooltipId?: string;
}

export function FieldDescriptionWrapper({
  title,
  description,
  tooltipId,
  children,
}: Props): JSX.Element {
  return (
    <FlexBox gap="200" justifyContent="space-between">
      <Box padding="0 500 0 0">
        <Text.Heading variant="heading-3" className={styles.title}>
          <FlexBox alignItems="center" gap="200">
            {title}{' '}
            {tooltipId && (
              <Icon
                name="question"
                data-elevio-inline={tooltipId}
                data-elevio-style="nothing"
                style={{ cursor: 'pointer' }}
              />
            )}
          </FlexBox>
        </Text.Heading>
        <Text.Paragraph variant="2">{description}</Text.Paragraph>
      </Box>
      {children}
    </FlexBox>
  );
}
